import axios from 'axios';
import {HEALTH_SERVICE} from "../../utils/constants/ContextConstants";

export class CommonService {
    getMicroserviceHealth(context) {
        return axios.get(context + HEALTH_SERVICE, {
            headers: {
                'Content-Type': 'application/json',
            },
        }).then(res => res)
            .catch(error => error.response);
    }

    getInstrumentData(instrumentName, serial, valueTypeInstrument, loanId) {
        return axios.get('/appapv/getInstrumentData.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                emisora: encodeURIComponent((instrumentName)),
                serie: encodeURIComponent((serial)),
                tipoValor: encodeURIComponent((valueTypeInstrument)),
                idFolioPrest: loanId,
            }
        }).then(res => res.data);
    }

    getLoanAndGuarantee(loanId) {
        return axios.get('/appapv/getLoanAndGuarantee.action', {
            params: {
                idFolioPrest: loanId
            }
        }).then(res => res.data.payload);
    }

    getLoan(loanId) {
        return axios.get('/appapv/getLoan.action', {
            params: {
                idFolioPrest: loanId
            }
        }).then(res => res.data.payload);
    }

    getGuarantee(loanId) {
        return axios.get('/appapv/getGuarantee.action', {
            params: {
                idFolioPrest: loanId
            }
        }).then(res => res.data.payload);
    }
}